import { ConnectionNames } from "../../../Contracts";
import { applyRESTQueries } from "../../../Common";
export function applyBetsReportingQueries(message) {
    return applyRESTQueries(ConnectionNames.betsReporting, message);
}
//# sourceMappingURL=ApplyBetsReportingQueries.js.map